export default __webpack_public_path__ + "static/media/Mask Group 87.fc140972.svg";